import type { Components, Theme } from '@mui/material/styles'

import { spacing } from '@/themes/tokens'

export const MuiDialogOverride: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      // MuiPaper's root override pads and rounds every Paper. Keep the radius,
      // but clear the padding — a dialog's title/content/actions each own theirs,
      // and inheriting Paper's would inset them a second time.
      padding: 0,
      backgroundColor: theme.palette.background.dialog,
    }),
  },
}

export const MuiDialogTitleOverride: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(spacing.md, spacing.lg, spacing.sm),
    }),
  },
}

export const MuiDialogContentOverride: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(spacing.md, spacing.lg),
    }),
  },
}

export const MuiDialogActionsOverride: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(spacing.md, spacing.lg),
    }),
  },
}
